export default __webpack_public_path__ + "static/media/matrix.d563efe9.svg";